export function initLottieAnimations() {
    
    const animations = document.querySelectorAll( '[data-lottie-animation]' );

    animations.forEach(animation => {

        let autoplaySetting = true;

        if ( animation.hasAttribute('data-lottie-interactive') ) {
            autoplaySetting = false;
        }

        const dotLottie = new window.DotLottie({
            autoplay: autoplaySetting,
            loop: true,
            canvas: animation,
            src: animation.getAttribute('data-lottie-animation'),
        });

        if ( animation.hasAttribute('data-lottie-interactive') ) {
            animation.parentNode.parentNode.addEventListener('mouseenter', () => {
                dotLottie.play();
            });
            animation.parentNode.parentNode.addEventListener('mouseleave', () => {
                dotLottie.pause();
            });
        }
    });
}